<template>
    <b-modal :id="`${id}-modal`" title="Patient Notes" hide-footer>
        <template v-if="entityId">
            <NotesList :entityId="entityId" :entityType="entityType" :pageSize="5"/>
        </template>
    </b-modal>
</template>

<script lang="ts">
import { Component, Prop, Vue} from 'vue-property-decorator';
import NotesList from "@/components/Note/NotesList.vue";
import { EntityType } from "@/models/EntityType";

@Component({
    name: "PatientNotesModalComponent",
    components: {
        NotesList,
    },
})
export default class PatientNotesModalComponent extends Vue {
    @Prop({ default: 'patient-notes' }) private id!: string;
    @Prop() private entityId!: number;

    mounted() {
        document.addEventListener('keydown', this.preventDefaultForHotkeys);
        document.addEventListener('keyup', this.hotKeysListener);
    }

    beforeDestroy() {
        document.removeEventListener("keydown", this.preventDefaultForHotkeys);
        document.removeEventListener("keyup", this.hotKeysListener);
    }

    preventDefaultForHotkeys(e: KeyboardEvent) {
        if (e.ctrlKey && e.key ==="p") e.preventDefault();
    }

    hotKeysListener(e: KeyboardEvent) {
        if (e.ctrlKey && e.key ==="p") this.$bvModal.show(`${this.id}-modal`);
    }

    get entityType() {
        return EntityType.Patient;
    }

    hideModal() {
        this.$bvModal.hide(`${this.id}-modal`);
    }
}

</script>

<style scoped>
</style>
